import Cookies from "js-cookie";

// const KayanURL = '/';
const KayanURL = "https://prod.kayan-healthcare.com/";
 const KsaURL="https://ksa.kayan-healthcare.com/"
 const apiToken = Cookies.get("SanadId");
const user = Cookies.get("user");

const samaApiToken = Cookies.get("SamaId");
const samaUser = Cookies.get("SamaUser");

let settings = {
  KayanURL,
  apiToken,
  user,
  samaApiToken,
  samaUser,
  KsaURL
};

export default settings;
